import { render, staticRenderFns } from "./NpcAction.vue?vue&type=template&id=422750b1&scoped=true&"
import script from "./NpcAction.vue?vue&type=script&lang=js&"
export * from "./NpcAction.vue?vue&type=script&lang=js&"
import style0 from "./NpcAction.vue?vue&type=style&index=0&id=422750b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422750b1",
  null
  
)

export default component.exports